import { render, staticRenderFns } from "./NewLeave.vue?vue&type=template&id=09e291bd&"
import script from "./NewLeave.vue?vue&type=script&lang=ts&"
export * from "./NewLeave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports